<template>
    <settings-page :title="title" :description="description">
        <settings-presets
            :type="type"
            :element-type="elementType"
            :preview-text="previewText"
            :default-classes="defaultClasses"
            @input="onInput"
        />
    </settings-page>
</template>

<script>

import SettingsPage from '@/components/settings/shared/settings-page';
import SettingsPresets from '@/components/settings/preset/settings-presets';

export default {
    name: 'settings-presets-link',
    components: { SettingsPage, SettingsPresets },

    data() {
        return {
            title: 'Link Presets',
            description: 'This is where you define your link presets. A “preset“ is a group of styles that can be be quickly added to a page element.',
            previewText: 'Learn More',

            elementType: 'a-link',
            type: 'link',
            defaultClasses: 'f-text-blue-700 f-text-1 f-font-default f-leading-normal f-font-normal f-no-underline f-cursor-pointer hover:f-text-blue-600 hover:f-underline',
        };
    },

    methods: {
        onInput(prop, data) {
            this.$emit('input', prop, data);
        },
    },
};
</script>
